const $ = window.jQuery;
import 'slick-carousel';

$(document).ready(function() {
    $('.block-carousel .carousel').slick({
        dots: true,
        fade: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1, 
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: true,
        adaptiveHeight: true,
        prevArrow: '<button type="button" class="slick-prev"><span class="screen-reader-text">Previous slide</span></button>',
        nextArrow: '<button type="button" class="slick-next"><span class="screen-reader-text">Next slide</span></button>'
    });
});